import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Vue2TouchEvents from 'vue2-touch-events'
import tachyons from 'tachyons'
import VueSimpleSVG from 'vue-simple-svg'
import * as VueGoogleMaps from 'vue2-google-maps'
import { VueHammer } from 'vue2-hammer'
Vue.config.productionTip = false

Vue.use(VueSimpleSVG)
Vue.use(VueHammer)

Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyC_Mym1SBKhiaWUqEyzHEsY18hf4SeITpY'
    key: 'AIzaSyD6Mt2iAZXJOZsxvvJ93-HzSbzx0rDvbt8'
  }
})

Vue.filter('formatType', function (value) {
  let houseType = ''
  switch (value) {
    case 'semi':
      houseType = 'Semi-detached'
      break
    case 'detached':
      houseType = 'Detached'
      break
    case 'apartment':
      houseType = 'Apartment'
      break
    default:
      break
  }
  return houseType
})

Vue.filter('formatAvailability', function (value) {
  let availability = ''
  switch (value) {
    case 'available':
      availability = 'Available'
      break
    case 'comingSoon':
      availability = 'Coming Soon'
      break
    case 'exchanged':
      availability = 'Exchanged Contracts'
      break
    case 'earlyBirdReserved':
      availability = 'Early Bird Reserved'
      break
    case 'notReleased':
      availability = 'Not Released'
      break
    case 'reserved':
      availability = 'Reserved'
      break
    case 'sharedOwnership':
      availability = 'Shared Ownership'
      break
    case 'sold':
      availability = 'Sold'
      break
    case 'soldOut':
      availability = 'Sold Out'
      break
    default:
      break
  }
  return availability
})
Vue.use(Vue2TouchEvents)
Vue.filter('formatPrice', function (value) {
  let price

  if (value === '') {
    price = 'TBC'
  } else {
    price = '£ ' + Intl.NumberFormat('en-US').format(value)
  }
  return price
})

new Vue({
  router,
  store,
  tachyons,
  render: h => h(App)
}).$mount('#app')
